import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import {
    newTag,
    fetchTagList,
    delTag,
    fetchList,
    deleteTv,
    setActivePage,
    setPageSize
} from "../TvList/actions";
import { updateTvInfo, reset_info } from "../TvInfo/actions";
import { Table, Button, Input, Tag, Popconfirm, message } from 'antd';
import { checkPermission } from '../../utils/utils';
import "../TvList/index.scss";


class TvArticleList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tag: '',
            showModal: false
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchList({
            type: 'a',
            page: this.props.activePage,
            pageSize: this.props.pageSize
        }));
        this.props.dispatch(fetchTagList());
    }

    recommend = (item, value) => {
        item.recommend = value;
        this.props.dispatch(updateTvInfo(item, 1));
    };

    handleConfirm = (id) => {
        this.props.dispatch(deleteTv(id, 'a'));
    };

    mdeleteTv = (e) => {
        e.preventDefault();
        this.setState({
            showModal: true,
            deleteId: e.target.getAttribute('data-target')
        });
    };

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    handleSelect = page => {
        this.props.dispatch(setActivePage(page));
        this.props.dispatch(fetchList({
            page: page,
            pageSize: this.props.pageSize,
            type: 'a'
        }));
    };

    createTag = () => {
        if (this.state.tag.trim() === "") {
            message.warn('请输入标签名')
            return;
        }

        this.props.dispatch(newTag(this.state.tag));
        this.setState({ tag: "" });
    };

    onShowSizeChange = async (current, pageSize) => {
        await this.props.dispatch(setActivePage(1));
        await this.props.dispatch(setPageSize(pageSize));

        this.props.dispatch(fetchList({
            page: this.props.activePage,
            pageSize: this.props.pageSize,
            type: 'a'
        }));
    }

    paginationChange = async page => {
        await this.props.dispatch(setActivePage(page));

        this.props.dispatch(fetchList({
            page: this.props.activePage,
            pageSize: this.props.pageSize,
            type: 'a'
        }));
    }

    // 先将content设置为undefined
    resetContent = async () => {
        await this.props.dispatch(reset_info());
        this.props.history.push("/tvArticleRelease");
    }

    /** 生成antd table的配置信息 */
    generateTableColumns = () => {
        let columns = [
            {
                title: '标题',
                width: '25%',
                render: (text, record) => (
                    checkPermission('news:tv:gkinfo') && <Link to={`/tvarticle/${record.id}`} className="title">{record.title}</Link>
                    || <span className="title">{record.title}</span>
                ),
            },
            {
                title: '分类',
                width: '25%',
                render: (text, record) => (
                    <span>{record.tvTag && record.tvTag.name}</span>
                ),
            },
            {
                title: '创建时间',
                width: '25%',
                dataIndex: 'createTime',
            },
            {
                title: '操作',
                render: (text, record) => {
                    return (
                        <div className="commonTableBtn">
                            {checkPermission('sys:tv:edit') &&
                                record.recommend > 0 ?
                                    <Button size="small" type="primary" danger onClick={() => this.recommend(record, 0)}>取消推荐</Button> :
                                    <Button size="small" type="primary" onClick={() => this.recommend(record, 1)}>推荐</Button>
                            }
                            {checkPermission('sys:tv:edit') &&
                                record.recommend != 2 &&
                                <Button size="small" type="primary" onClick={() => this.recommend(record, 2)}>置顶</Button>
                            }
                            <Popconfirm
                                title="确定要删除该视频吗?"
                                onConfirm={() => this.handleConfirm(record.id)}
                                okText="Yes"
                                cancelText="No"
                            >
                                {checkPermission('gknews:tv:del') && <Button size="small" type="primary">删除</Button>}
                            </Popconfirm>
                        </div>

                    )
                }
            }

        ];
        return columns;
    }

    tableTitleRender = () => (
        <div className="commonTableTitle">
            <span>tv文章列表</span>
            {checkPermission('gknews:tv:edit') &&
                <Button type="primary" onClick={this.resetContent}>添加tv文章</Button>
            }
        </div>
    )

    render() {
        return (
            <div>
                <h4>tv文章列表</h4>
                <div className="mb20">
                    {checkPermission('sys:tvTag:edit') && <div>
                        <label>标签</label>
                        <Input style={{ width: '60%', margin: '0 10px 10px 0' }} value={this.state.tag} onChange={e => this.setState({ tag: e.target.value })} className="mb20 mr10" />
                        <Button type="primary" onClick={this.createTag} disabled={this.props.isSend}>创建标签</Button>
                    </div>}
                    {checkPermission('sys:tvTag:list') &&
                        this.props.tags.map((tag, idx) => (
                            <Tag color='blue' key={idx} closable={checkPermission('sys:tvTag:del')} onClose={() => this.props.dispatch(delTag(tag.id))}>{tag.name}</Tag>
                        ))
                    }
                </div>
                <Table
                    columns={this.generateTableColumns()}
                    dataSource={this.props.tvs}
                    rowKey={record => record.id}
                    title={this.tableTitleRender}
                    loading={this.props.isFetching}
                    pagination={{
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onChange: this.paginationChange,
                        onShowSizeChange: this.onShowSizeChange,
                        current: this.props.page,
                        pageSize: this.props.pageSize,
                        total: this.props.totalElements,
                        showTotal: total => `共有${total}条数据`,
                    }}
                />
            </div>
        )
    }

}

function mapStatetoProps(state) {
    return {
        ...state.tvList,
    };
}

export default connect(mapStatetoProps)(TvArticleList);
